export default __webpack_public_path__ + "static/media/main-image.2de466bb.svg";